import { Text } from '@mantine/core'
import { TFunction } from 'i18next'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

// export const freeMinBalance = Number(process.env.IDENTITY_MIN_BALANCE || '0.05')

const getFreeUsernameText = (t: TFunction) => ({
  freeLabel: t('components.identity.freeUserLabel', 'Type in a username you want to use'),
  freeModalTitle: t('components.identity.freeUserModalTitle', 'Confirm Your Username'),
  freeTitleArea: t('components.identity.freeUserTitleArea', 'Set Your Username'),
  freeCheckAvailabilityButtonText: t(
    'components.identity.freeUserAvailabilityBtn',
    'Check Availability'
  ),
})

export function useFreeUsernameText() {
  const { t } = useTranslation()
  return getFreeUsernameText(t)
}

interface FreeTextAreaProps {
  className: any
  createProfile?: boolean
}
export const FreeTextArea: React.FC<FreeTextAreaProps> = ({ className, createProfile }) => (
  <Text className={className}>
    {createProfile ? (
      <Trans i18nKey="components.identity.createProfileArea">
        On LAMINA1, every account has a public Profile. Yours is identified by the alphanumeric
        address below:
      </Trans>
    ) : (
      <Trans i18nKey="components.identity.freeUserTextArea">
        Your username is a unique, public identifier that will be linked to your Profile and
        activity across LAMINA1.
      </Trans>
    )}
  </Text>
)
